// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CardMedia,
//   CircularProgress,
//   Container,
//   InputAdornment,
//   TextField,
//   Typography,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import SearchIcon from "@mui/icons-material/Search";
// import { overviewMainInfraData } from "../../../data/data";
// import { useNavigate } from "react-router-dom";
// import { useQuery } from "@apollo/client";
// import React, { useState } from "react";
// import { GET_AVAILABLE_INTEGRATIONS } from "../../../apis/organization-apis/people-apis/peopleApis";

// import { useDispatch } from "react-redux";
// import { dispatchSetInfraType } from "../../Organization/InfraManagement/store/dispatcher";

// const AccessMain = () => {
//   let navigate = useNavigate();
//   let dispatcher = useDispatch();

//   const { data, loading } = useQuery(GET_AVAILABLE_INTEGRATIONS, {
//     variables: {
//       category: "infra",
//     },
//   });

//   const handleRedirectOverview = (infra) => {
//     navigate("/access/overview");
//     dispatcher(dispatchSetInfraType(infra));
//     localStorage.setItem("infraType", infra);
//   };

//   const getImage = (logo) => {
//     try {
//       // Dynamically resolve the logo path
//       return require(`../../../Assets/Images/${logo}.png`);
//     } catch (error) {
//       console.error(`Error loading image: ${logo}`, error);
//       // Return a default logo if the specific one is not found
//       // return require("../../../Assets/Images/soc_2.jpeg");
//     }
//   };

//   if (loading) {
//     return (
//       <Container
//         component="main"
//         maxWidth="xs"
//         sx={{ textAlign: "center", mt: 8 }}
//       >
//         <CircularProgress />
//       </Container>
//     );
//   }

//   return (
//     <div>
//       <Box>
//         <Typography variant="h5" noWrap sx={{ fontWeight: "bold" }}>
//           Overview
//         </Typography>
//         <Box display="flex" justifyContent="space-between">
//           <Typography sx={{ width: "50%" }} color="text.secondary">
//             Streamline infrastructure management with secure cloud integration,
//             ensuring seamless access and robust protection for your systems and
//             data.
//           </Typography>
//           <Box>
//             <Button
//               variant="outlined"
//               startIcon={<AddIcon />}
//               sx={{ fontWeight: "700" }}
//             >
//               Add critical system
//             </Button>
//           </Box>
//         </Box>
//         <TextField
//           placeholder="Search Critical Systems"
//           fullWidth
//           size="small"
//           sx={{ my: "30px" }}
//           slotProps={{
//             input: {
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             },
//           }}
//         />
//         <Box
//           sx={{
//             display: "flex",
//             gap: 2,
//             flexWrap: "wrap",
//           }}
//         >
//           {data?.getAvailableIntegrations?.list &&
//             data?.getAvailableIntegrations?.list.map((item, i) => {
//               return (
//                 <React.Fragment key={i}>
//                   <Card
//                     sx={{
//                       minWidth: "200px",
//                       backgroundColor: "#F2F2F7",
//                       cursor: "pointer",
//                       boxShadow: "unset",
//                     }}
//                     onClick={() => handleRedirectOverview(item.label)}
//                   >
//                     <CardContent
//                       sx={{
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <CardMedia
//                         component="img"
//                         // image={() => getImage(item.label)}
//                         src={getImage(item.label)}
//                         alt={item.label}
//                         sx={{
//                           height: 25, // Adjust based on your icon size
//                           width: 30, // Adjust based on your icon size
//                           objectFit: "contain",
//                           marginTop: 2,
//                           backgroundColor: "white",
//                           borderRadius: "15%",
//                           padding: "15px",
//                         }}
//                       />

//                       <Typography
//                         textAlign="center"
//                         marginTop="10px"
//                         textTransform="uppercase"
//                       >
//                         {item.label}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </React.Fragment>
//               );
//             })}
//         </Box>
//       </Box>
//     </div>
//   );
// };

// export default AccessMain;


import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import SystemsTab from "./Overview/SystemsTab";
import AccessMatrixTab from "./AccessMatrix/AccessMatrixTab";

const AccessMain = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2, px: 2, pt: 0.5 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: "14px",
              minHeight: "48px",
            },
            "& .Mui-selected": {
              fontWeight: 600,
            },
          }}
        >
          <Tab label="Overview" />
          <Tab label="Access Matrix" />
        </Tabs>
      </Box>

      {activeTab === 0 && <SystemsTab />}
      {activeTab === 1 && <AccessMatrixTab />}
    </Box>
  );
};

export default AccessMain;
